import React from 'react'

import { Box, colors, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const TwoFactorAuthenticationStepSkeleton = () => (
  <Grid container spacing={6} justifyContent="center">
    <Grid item xs={12} md={8}>
      <Box display="flex" justifyContent="center">
        <Skeleton variant="text" width="60%" height={48} />
      </Box>
    </Grid>
    <Grid item xs={12}>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            border={`1px solid ${colors.grey[300]}`}
            gridGap={3}
            px={3}
            py={2}
            borderRadius={4}
          >
            <Skeleton variant="text" width="80%" height={28} />
            <Skeleton variant="rect" width="100%" height={56} />
            <Skeleton variant="text" width="40%" height={24} />
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <Box display="flex" justifyContent="center">
            <Skeleton variant="rect" width={304} height={78} />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
)

export default TwoFactorAuthenticationStepSkeleton
